import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';
import SubmitForm from '../views/SubmitForm.vue';
import ProfilePage from '../views/ProfilePage.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    props: (route) => ({ phrases: route.params.phrases || [] }),
  },
  {
    path: '/submit',
    name: 'Submit',
    component: SubmitForm,
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfilePage,
  },
  {
    path: '/phrase/:slug',
    name: 'PhraseDetail',
    component: () => import('@/components/PhraseDetail.vue'),
    props: true,
  },
  {
    path: '/about',
    name: 'AboutUs',
    component: () => import('@/components/AboutUs.vue'),
  },
  {
    path: '/ranking',
    name: 'Ranking',
    component: () => import('@/views/LeaderboardPage.vue'),
  },
  {
    path: '/blog',
    name: 'Blog',
    component: () => import('@/views/BlogPage.vue'),
  },
  {
    path: '/user/:username/words',
    name: 'UserWords',
    component: () => import('@/views/UserWordsPage.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'Home' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});


export default router;
